/**
 * Runtime configuration helper
 * 
 * This allows environment variables to be set at container runtime
 * instead of being baked in at build time.
 * 
 * Priority:
 * 1. window.RUNTIME_CONFIG (set by config.js, replaced at container startup)
 * 2. process.env (build-time fallback for development)
 */

const getConfig = (key) => {
  // Check runtime config first (for production Docker deployments).
  // Use `in` + startsWith rather than truthiness so an intentionally empty
  // string (same-origin) isn't mistaken for "not configured".
  const runtimeConfig = window.RUNTIME_CONFIG;
  if (runtimeConfig && key in runtimeConfig && !String(runtimeConfig[key]).startsWith('__')) {
    return runtimeConfig[key];
  }

  // Fall back to build-time env vars (for development)
  return process.env[key];
};

export const config = {
  // ?? (not ||): an empty string means same-origin and must be preserved,
  // only fall back to localhost:8001 when truly unset (e.g. `yarn start`).
  BACKEND_URL: getConfig('REACT_APP_BACKEND_URL') ?? 'http://localhost:8001',
  SITE_TITLE: getConfig('REACT_APP_SITE_TITLE') || 'ProjectHub',
};

export default config;
